import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createAccountBusinessFile } from "../../../../../api/correspondent/CorresspondentApi";
import { useModal } from "../../../../../hooks";
import { AxiosError } from "axios";

type Props = {
  setRead: () => void;
};

export const useCreateAccountBusinessFile = ({ setRead }: Props) => {
  const { handleModal } = useModal();
  const queryClient = useQueryClient();
  const { mutate } = useMutation({
    mutationFn: (data: FormData) => createAccountBusinessFile(data),
    onSuccess: (res) => {
      setRead();

      queryClient.invalidateQueries({
        queryKey: ["readAccountBasicInfo"],
      });
    },
    onError: (error: AxiosError<{ msg?: string }>) => {
      if (error?.response?.data?.msg) {
        handleModal({
          isOpen: true,
          contents: error?.response?.data?.msg || '오류! 내용을 다 삽입했는지, 중복되었는지 확인하세요',
          type: "alert",
        });
      }
    },
  });

  return { mutate };
};
